import { render, staticRenderFns } from "./StowageInstructionPage.vue?vue&type=template&id=d5abbbfe&scoped=true"
import script from "./StowageInstructionPage.vue?vue&type=script&ts=true&lang=js"
export * from "./StowageInstructionPage.vue?vue&type=script&ts=true&lang=js"
import style0 from "./StowageInstructionPage.vue?vue&type=style&index=0&id=d5abbbfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5abbbfe",
  null
  
)

export default component.exports